import './Uniao.css'
import '../../../variaveis.css'

const SessaoUniao = () => {
    return (
        <section className='containerUniao'>
            <h1>A união da <span>inovação</span> e <span>educação</span> em uma única <span>solução</span></h1>
            
            <article className='solucao'>
                <p>
                    Explorar e aprender tudo sobre o carro da Fórmula E nunca foi tão fácil.
                </p>
                <div></div>
                <p>
                    Através do nosso carro em 3D, você pode conhecer todas as especificações e tecnologias que tornam a Fórmula E tão especial.
                </p>
            </article>
        </section>
    )
}

export default SessaoUniao